<template>
  <!--
    遮罩层 z-index: 99
    wave动画 z-index: 100
  -->
  <transition name="fade">
    <div class="animate" v-show="isShow">
      <!--遮罩层-->
      <div id="mask" key="mask"></div>
      <!--wave动画-->
      <div class="col-sm-2" key="wave">
        <div id="wave1"></div>
        <h5>wave1</h5>
      </div>
    </div>
  </transition>
</template>

<script>
  import { ref } from 'vue'
  export default {
    name: "Animate",
    setup(){

      let isShow = ref(true)

      return{ isShow}
    }
  }
</script>

<style scoped lang="less">

  .fade-enter-from{
    opacity: 0
  }
  .fade-enter-active{
    transition: all 5s;
  }
  /*.fade-enter-to{
    opacity: 1
  }*/
  .fade-leave-from {
    opacity: 1
  }
  .fade-leave-active {
    transition: all .5s;
  }
  .fade-leave-to {
    opacity: 0
  }


  .animate{
    // 没别的目的 知识将animate脱标
    position: absolute;
    // 遮罩层
    #mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      /* you can change color of mask here*/
      background: #f3f3f3;
      //background: pink;
      z-index: 99;
      /* makes sure it stays on top */
    }
    // 页面加载样式
    .col-sm-2 {
      padding: 10px;
      border-radius: 4px;
      height: 125px;
      margin-bottom: 10px;
      box-shadow: 0 0 1px #000;
      border: 1px solid skyblue;
    }
    // 正式样式
    #wave1 {
      display: block;
      position: fixed;
      top: 50%;
      left: 50%;
      height: 50px;
      width: 50px;
      margin: -25px 0 0 -25px;
      border-radius: 50%;
      z-index: 100;
    }

    #wave1:before, #wave1:after {
      content: '';
      border: 2px solid #008744;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      position: absolute;
      left: 0px;
    }

    #wave1:before {
      -webkit-transform: scale(1, 1);
      -ms-transform: scale(1, 1);
      transform: scale(1, 1);
      opacity: 1;
      -webkit-animation: spWaveBe 0.6s infinite linear;
      animation: spWaveBe 0.6s infinite linear;
    }

    #wave1:after {
      -webkit-transform: scale(0, 0);
      -ms-transform: scale(0, 0);
      transform: scale(0, 0);
      opacity: 0;
      -webkit-animation: spWaveAf 0.6s infinite linear;
      animation: spWaveAf 0.6s infinite linear;
    }

    @-webkit-keyframes spWaveAf {
      from {
        -webkit-transform: scale(0.5, 0.5);
        transform: scale(0.5, 0.5);
        opacity: 0;
      }
      to {
        -webkit-transform: scale(1, 1);
        transform: scale(1, 1);
        opacity: 1;
      }
    }
    @keyframes spWaveAf {
      from {
        -webkit-transform: scale(0.5, 0.5);
        transform: scale(0.5, 0.5);
        -webkit-transform: scale(0.5, 0.5);
        transform: scale(0.5, 0.5);
        opacity: 0;
      }
      to {
        -webkit-transform: scale(1, 1);
        transform: scale(1, 1);
        -webkit-transform: scale(1, 1);
        transform: scale(1, 1);
        opacity: 1;
      }
    }
    @-webkit-keyframes spWaveBe {
      from {
        -webkit-transform: scale(1, 1);
        transform: scale(1, 1);
        opacity: 1;
      }
      to {
        -webkit-transform: scale(1.5, 1.5);
        transform: scale(1.5, 1.5);
        opacity: 0;
      }
    }
    @keyframes spWaveBe {
      from {
        -webkit-transform: scale(1, 1);
        transform: scale(1, 1);
        opacity: 1;
      }
      to {
        -webkit-transform: scale(1.5, 1.5);
        transform: scale(1.5, 1.5);
        opacity: 0;
      }
    }

  }

</style>